import styled, { keyframes } from 'styled-components';

const animateEnter = keyframes`
  100%{
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  60%{
    transform: translate(-50%, -50%) scale(1.1);

  }
  0%{
    opacity: 0;
    transform: translate(-50%, -50%) scale(.8);
  }
`;

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 30px;
  overflow: hidden;

  & > [role='dialog'] {
    animation: ${animateEnter} forwards 650ms;
  }
`;
